var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activity)?_c('div',{staticClass:"notify"},[_c('Banner'),_c('div',{staticClass:"notify-wrap",domProps:{"innerHTML":_vm._s(_vm.activity.hint)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }